/* eslint-disable */

// NumberBoxNode.tsx
import {
  DecoratorNode,
  DOMConversionMap,
  DOMConversionOutput,
  DOMExportOutput,
  EditorConfig,
  LexicalEditor,
  LexicalNode,
  NodeKey,
  SerializedLexicalNode,
  Spread,
} from 'lexical';
import * as React from 'react';
import { Suspense } from 'react';

const NumberBoxComponent = React.lazy(() => import('./CasLexicalInputNumber'));

export type SerializedNumberBoxNode = Spread<
  {
    data: string;
    type: 'numberbox';
    version: 1;
  },
  SerializedLexicalNode
>;

function convertNumberBoxElement(domNode: HTMLElement): DOMConversionOutput | null {
  const data = domNode.textContent;
  if (data) {
    const node = $createNumberBoxNode(data);
    return { node };
  }
  return null;
}

export class CasLexicalInputNumberNode extends DecoratorNode<JSX.Element> {
  __data: string;

  static getType(): string {
    return 'numberbox';
  }

  static clone(node: CasLexicalInputNumberNode): CasLexicalInputNumberNode {
    return new CasLexicalInputNumberNode(node.__data, node.__key);
  }

  static importJSON(serializedNode: SerializedNumberBoxNode): CasLexicalInputNumberNode {
    return new CasLexicalInputNumberNode(serializedNode.data);
  }

  exportJSON(): SerializedNumberBoxNode {
    return {
      data: this.__data,
      type: 'numberbox',
      version: 1,
    };
  }

  constructor(data = '0', key?: NodeKey) {
    super(key);
    this.__data = data;
  }

  createDOM(): HTMLElement {
    const span = document.createElement('span');
    return span;
  }

  updateDOM(): false {
    return false;
  }

  static importDOM(): DOMConversionMap<HTMLSpanElement> {
    return {
      span: (domNode: HTMLSpanElement) => {
        if (!domNode.hasAttribute('data-lexical-numberbox-json')) return null;
        return {
          conversion: convertNumberBoxElement,
          priority: 1,
        };
      },
    };
  }

  exportDOM(): DOMExportOutput {
    const element = document.createElement('span');
      const parsed = JSON.parse(this.__data);
      if (parsed?.response?.name) {
        element.setAttribute('data-lexical-numberbox-json', `Branch: ${parsed.response.name}`);
        element.innerText = JSON.stringify(parsed.response);
      }
    return { element };
  }

  setData(data: string): void {
    const self = this.getWritable();
    self.__data = data;
  }

  decorate(editor: LexicalEditor, config: EditorConfig): JSX.Element {
    return (
      <Suspense fallback={null}>
        <NumberBoxComponent nodeKey={this.getKey()} data={this.__data} />
      </Suspense>
    );
  }
}

export function $createNumberBoxNode(
  data = JSON.stringify({ inputNumber: '', response: null, openDialog: true })
): CasLexicalInputNumberNode {
  return new CasLexicalInputNumberNode(data);
}

export function $isNumberBoxNode(node: LexicalNode | null): node is CasLexicalInputNumberNode {
  return node instanceof CasLexicalInputNumberNode;
}
